import { defineStore } from "pinia";
import services from "./services";
import Helper from "@/common/Helper";
import moment from "moment";
import { User, useUserStore } from "./UserStore";
import { Configuracion } from "./CommonStore";
import { ElNotification, ElLoading } from "element-plus";
import {
  ProductoAcabado,
  useProductosAcabadoStore,
} from "./ProductosAcabadoStore";
import { Material, useMaterialesStore } from "./MaterialesStore";
import { Proyecto, useProyectosStore } from "./ProyectosStore";
import { useFasesStore } from "./FaseStore";
export enum TiposTareas {
  Proyecto = "Proyecto",
  PA = "PA",
  Material = "Material",
}
export enum EstadosTareas {
  NotStarted = "Not started",
  Finished = "Finished",
  OnTime = "On time",
  Delayed = "Delayed",
  ProyectoNoIniciado = "Proyecto no iniciado",
}

export interface TareaBBDD {
  Id: number;
  IdOrigen: number;
  IdProyecto: number;
  IdPA: number;
  IdMaterial: number;
  Dependencia: string;
  Fase: number;
  TipoTarea: string;
  Descripcion: string;
  Departamento?: string;
  AsignadoA?: string;
  FechaInicio: string;
  FechaCaducidad: string;
  FechaFin?: string;
  Completada: boolean;
  CompletadaPor?: string;
  TareaActiva: boolean;
  SAPAutoConsumo: boolean;
  PlantillaEmailCompletada?: string;
}
export interface TareaBBDDExtend extends TareaBBDD {
  [key: string]: any;
}
export interface GestionTareasTable extends TareaBBDD {
  FaseText?: string;
  children?: GestionTareasTable[];
}
export interface TareaBBDDData extends TareaBBDD {
  Proyecto: string;
  PA?: string;
  Material?: string;
  ComentarioPackaging?:string;
  TipoMaterial?:string;
  EstadoSAP?:string;
}
export interface DataGantt {
  id: number;
  text: string;
  start_date: string;
  end_date: string | Date | undefined;
  duration: number;
  progress: number;
  owner_id: string;
  deadline: string;
  planned_start: string;
  planned_end: string | Date | undefined;
  parent?: number;
  open: boolean;
  isParent: boolean;
  finished: boolean;
}
export interface LinkGantt {
  id: string;
  source: number;
  target: number;
  type: string;
}
export interface TareasGantt {
  data: DataGantt[];
  links: LinkGantt[];
}

export interface TareaConfiguracion {
  Id: number;
  Orden: number;
  Descripcion: string;
  Duracion: number;
  Dependencia: string;
  Departamento: string;
  Fase: number;
  PersonaClave: string;
  EquipoExtended: string;
  TipoTarea: string;
  CompletarNoCambio: boolean;
  MaterialCambioCodigo: boolean;
  SAPAutoConsumo: boolean;
  PlantillaEmailCompletada?: string;
}
export interface TareasEquiposConfig {
  Key: string;
  Tareas: TareaConfiguracion[];
}
// export interface ReferenciaMateriales extends Referencia {
//     Materiales: Material[]
// }
export const useTareasStore = defineStore("TareaStore", {
  // convert to a function
  state: () => ({
    Tareas: { data: [], links: [] } as TareasGantt,
    GestionTareas: [] as GestionTareasTable[],
    GestionTareasListado: [] as TareaBBDD[],
    TareasIdProyecto: [] as TareaBBDD[],
    TareasLoaded: false,
    TareasConfiguracion: [] as TareasEquiposConfig[],
    TareasPendientes: [] as TareaBBDDData[],
    TareasPendientesLoading: false,
    NumTareasPendientes: 0
  }),
  getters: {
    GetNumberTareasPendientes(state) {
      return state.TareasIdProyecto.filter((task) => !task.Completada);
    },
    GetNumberTareasDelayed(state) {
      return state.TareasIdProyecto.filter((task) => {
        const dueDate = moment(task.FechaCaducidad).endOf("day");
        return dueDate < moment() && task.FechaFin === null;
      });
    },
    GetNumberTareasProximasVencer(state) {
      return state.TareasIdProyecto.filter((task) => {
        const dueDate = moment(task.FechaCaducidad).endOf("day");
        const now = moment();
        const nextWeek = moment().add(7, "days").endOf("day");
        return dueDate >= now && dueDate <= nextWeek && task.FechaFin === null;
      });
    },
  },
  actions: {
    async GetByIdProyectoGantt(idProyecto: number) {
      //  tareas de bbdd
      const dateKey = new Date().getTime();
      this.TareasLoaded = false;
      const today = moment();
      const { groupBy } = Helper();
      const ProductosAcabadosStore = useProductosAcabadoStore();
      const MaterialesStore = useMaterialesStore();
      const tareasbbdd =
        await services.TareaService.getByIdProyecto(idProyecto);
      if (tareasbbdd.data && tareasbbdd.data.length > 0) {
        this.TareasIdProyecto = tareasbbdd.data;

        const idsPAsGroup = groupBy(tareasbbdd.data, "IdPA");
        const idsPAs = Object.keys(idsPAsGroup);
        const idsPasFiter = idsPAs.filter((i) => i !== "0");
        for (let i = 0; i < idsPasFiter.length; i++) {
          const idPa = idsPasFiter[i];
          const pa = ProductosAcabadosStore.ProductosAcabados?.find(
            (pa) => pa.IdPA === Number(idPa)
          );
          if (pa) {
            this.Tareas.data.push({
              id: Number(idPa) + dateKey,
              text: pa?.Descripcion,
              start_date: "",
              end_date: "",
              duration: 0,
              progress: 0,
              owner_id: "",
              deadline: "",
              planned_start: "",
              planned_end: "",
              open: true,
              isParent: true,
              finished: false,
            });
            const idsMaterialGrouped = groupBy(
              tareasbbdd.data.filter((t) => t.IdPA === Number(idPa)),
              "IdMaterial"
            );
            const idsMaterial = Object.keys(idsMaterialGrouped);
            await MaterialesStore.GetMaterialesByProductoAcabado(Number(idPa));
            idsMaterial
              .filter((i) => i !== "0")
              .forEach((idMat) => {
                const material = MaterialesStore.MaterialesPA?.find(
                  (m) => m.IdMaterial === Number(idMat)
                );
                if (material) {
                  this.Tareas.data.push({
                    id: material.IdMaterial + dateKey,
                    text: material.Descripcion,
                    start_date: "",
                    end_date: "",
                    duration: 0,
                    progress: 0,
                    owner_id: "",
                    deadline: "",
                    planned_start: "",
                    planned_end: "",
                    open: true,
                    parent: Number(idPa) + dateKey,
                    isParent: true,
                    finished: false,
                  });
                }
              });
          }
        }
        for (let t = 0; t < tareasbbdd.data.length; t++) {
          const task: TareaBBDD = tareasbbdd.data[t];

          const startDateTime = moment(task.FechaInicio);
          const dueDateTime = moment(task.FechaCaducidad);
          const startDate = startDateTime.startOf("day");
          const dueDate = dueDateTime.endOf("day");
        
          const endDateTime = task.FechaFin ? new Date(task.FechaFin) : null;
          const endDate = endDateTime
          ? new Date(endDateTime.getFullYear(), endDateTime.getMonth(), endDateTime.getDate() + 1, 0, 0, 0, 0)
          : undefined;

          const duracion = dueDate.diff(startDate, "days");
          const usersName = [];
          const assignments = task.AsignadoA?.split(";");
          if (assignments) {
            for (let i = 0; i < assignments.length; i++) {
              const user: User = await services.AzureService.getUserById(
                assignments[i]
              );
              if (user) {
                usersName.push(user.displayName);
              }
            }
          }

          let progress = 0;
          if (task.Completada) {
            progress = 100; // La tarea está completada
          } else {
            const totalTime = dueDate.diff(startDate, "days");
            const elapsedTime = today.diff(startDate, "days");
            progress = (elapsedTime / totalTime) * 100;
            progress = Math.min(progress, 100);
          }

          let parent = 0;
          if (task.IdMaterial !== 0) parent = task.IdMaterial + dateKey;
          else if (task.IdPA !== 0) parent = task.IdPA + dateKey;
          this.Tareas.data.push({
            id: task.Id,
            text: task.Descripcion,
            start_date: startDate.startOf("day").format("YYYY-MM-DDTHH:mm:ssZ"),
            end_date: endDate ? moment(endDate).format("YYYY-MM-DDTHH:mm:ssZ") : dueDate.format("YYYY-MM-DDTHH:mm:ssZ"),
              // ? moment(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ssZ")
              // : dueDate.endOf("day").format("YYYY-MM-DDTHH:mm:ssZ"),
            duration: duracion,
            progress: progress,
            owner_id: usersName.join(", "),
            deadline: dueDate.endOf("day").format("YYYY-MM-DDTHH:mm:ssZ"),
            planned_start: startDate
              .startOf("day")
              .format("YYYY-MM-DDTHH:mm:ssZ"),
            planned_end: endDate
              ? moment(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ssZ")
              : dueDate.endOf("day").format("YYYY-MM-DDTHH:mm:ssZ"),
            parent: parent,
            open: true,
            isParent: false,
            finished: endDate ? true : false,
          });

          if (task.Dependencia && task.Dependencia !== "0") {
            const dependencias = task.Dependencia.split(";").map(Number);

            const tareasPadre = tareasbbdd.data.filter((td) =>
              dependencias.includes(td.IdOrigen)
            );

            const agregarLink = (tareaPadre: TareaBBDD) => {
              const { TipoTarea, Id, IdPA, IdMaterial, IdOrigen } = tareaPadre;

              const condiciones = [
                TipoTarea === TiposTareas.Proyecto &&
                  dependencias.includes(IdOrigen),
                TipoTarea === TiposTareas.PA && task.IdPA === IdPA,
                TipoTarea === TiposTareas.Material &&
                  task.IdMaterial === IdMaterial,
              ];

              if (condiciones.some(Boolean)) {
                this.Tareas.links.push({
                  id: `${task.Id}-${Id}`, 
                  source: Id,
                  target: task.Id,
                  type: "0",
                });
              }
            };

            tareasPadre.forEach((tareaPadre) => {
              if (tareaPadre) agregarLink(tareaPadre);
            });
          }
        }
        this.Tareas.data.sort((a, b) => {
          const dateA = new Date(a.start_date).getTime();
          const dateB = new Date(b.start_date).getTime();
          return dateA - dateB;
        });
      } else {
        this.EmptyTareas();
      }
      this.TareasLoaded = true;
    },
    async GetTareasPendientesLeanOffice() {
      const allTareas = await services.TareaService.getPendientes('');
      return allTareas.data;
    },
    async GetAllTareasPendientes(idProyecto: number | null) {
      this.TareasPendientes = [];
      this.TareasPendientesLoading = true
      const UserStore = useUserStore();
      const ProyectosStore = useProyectosStore();
      const ProductosAcabadosStore = useProductosAcabadoStore();
      const MaterialesStore = useMaterialesStore();
      const { groupBy } = Helper();
      const allTareas = await services.TareaService.getPendientes(
        UserStore.CurrentUser.id
      );
      let tareas = allTareas.data;
      if (idProyecto) {
        tareas = allTareas.data.filter((t) => t.IdProyecto === idProyecto);
      }
      const idsProyecto: number[] = Object.keys(
        groupBy(tareas, "IdProyecto")
      ).map(Number);
      const idsPAs: number[] = Object.keys(groupBy(tareas, "IdPA")).map(Number);
      const idsMateriales: number[] = Object.keys(
        groupBy(tareas, "IdMaterial")
      ).map(Number);
      await ProyectosStore.GetProyectos();
      const proyectosConTareas = ProyectosStore.Proyectos?.filter((p) =>
        idsProyecto.includes(p.IdProyecto)
      );
      const pasConTareas =
        await ProductosAcabadosStore.GetProductosAcabadosByIds(idsPAs);
      const materialesConTareas =
        await MaterialesStore.GetMaterialesByIds(idsMateriales);
        this.TareasPendientes = tareas.map((tarea) => {
          const proyecto = proyectosConTareas?.find(p => p.IdProyecto === tarea.IdProyecto);
          const pa = pasConTareas.data?.find(pa => pa.IdPA === tarea.IdPA);
          const material = materialesConTareas.data?.find(m => m.IdMaterial === tarea.IdMaterial);
        
          return {
            ...tarea,
            Proyecto: proyecto?.Descripcion ?? '',
            PA: pa ? `${pa.Codigo} - ${pa.Descripcion}` : '',
            Comentario: proyecto?.Comentario ?? '',
            Material: material ? `${material.Codigo} - ${material.Descripcion}` : '',
            EstadoSAP: pa?.EstadoSAP ?? '',
            TipoMaterial: material?.Tipo ?? '',
          };
        });    
        this.TareasPendientesLoading = false    
        this.NumTareasPendientes = this.TareasPendientes.filter(t => t.TareaActiva).length
    },
    async GetByIdProyecto(idProyecto: number) {
      this.GestionTareas = [];
      this.GestionTareasListado = [];
      // const UserStore = useUserStore()
      // const ProyectosStore = useProyectosStore()
      const ProductosAcabadosStore = useProductosAcabadoStore();
      const MaterialesStore = useMaterialesStore();
      const FaseStore = useFasesStore();
      const { groupBy } = Helper();
      const allTareas = await services.TareaService.getByIdProyecto(idProyecto);
      this.GestionTareasListado = allTareas.data;
      const idsPAs: number[] = Object.keys(groupBy(allTareas.data, "IdPA")).map(
        Number
      );
      const idsMateriales: number[] = Object.keys(
        groupBy(allTareas.data, "IdMaterial")
      ).map(Number);
      // const proyecto = ProyectosStore.Proyectos?.find(p => idProyecto === p.IdProyecto)
      const pas =
        await ProductosAcabadosStore.GetProductosAcabadosByIds(idsPAs);
      const materiales =
        await MaterialesStore.GetMaterialesByIds(idsMateriales);
      allTareas.data.forEach((tarea) => {
        const fase = FaseStore.Fases?.find((f) => f.Id === tarea.Fase);
        if (tarea.IdPA > 0) {
          const pa = pas.data?.find((m) => m.IdPA === tarea.IdPA);
          let tareaPAPadre = this.GestionTareas.find(
            (t) =>
              t.Descripcion === pa?.Codigo + " - " + pa?.Descripcion &&
              t.IdPA === pa?.IdPA
          );
          if (!tareaPAPadre) {
            this.GestionTareas.push({
              Id: pa?.IdPA as number,
              IdOrigen: 0,
              IdProyecto: pa?.IdProyecto as number,
              IdPA: pa?.IdPA as number,
              IdMaterial: 0,
              Dependencia: "",
              Fase: 0,
              TipoTarea: TiposTareas.PA,
              Descripcion: pa?.Codigo + " - " + pa?.Descripcion,
              FechaInicio: "",
              FechaCaducidad: "",
              Completada: false,
              TareaActiva: false,
              children: [],
              SAPAutoConsumo: false,
              PlantillaEmailCompletada: ""
            });
            tareaPAPadre = this.GestionTareas.find(
              (t) =>
                t.Descripcion === pa?.Codigo + " - " + pa?.Descripcion &&
                t.IdPA === pa?.IdPA
            );
          }
          if (tarea.IdMaterial > 0 && tareaPAPadre) {
            const material = materiales.data?.find(
              (m) => m.IdMaterial === tarea.IdMaterial
            );
            let tareaMaterialPadre = tareaPAPadre.children?.find(
              (t) =>
                t.Descripcion ===
                  material?.Codigo + " - " + material?.Descripcion &&
                t.IdMaterial === material?.IdMaterial
            );
            if (!tareaMaterialPadre) {
              tareaPAPadre.children?.push({
                Id: material?.IdMaterial as number,
                IdOrigen: 0,
                IdProyecto: pa?.IdProyecto as number,
                IdPA: material?.IdPA as number,
                IdMaterial: material?.IdMaterial as number,
                Dependencia: "",
                Fase: 0,
                TipoTarea: TiposTareas.PA,
                Descripcion: material?.Codigo + " - " + material?.Descripcion,
                FechaInicio: "",
                FechaCaducidad: "",
                Completada: false,
                TareaActiva: false,
                children: [],
                SAPAutoConsumo: false,
                PlantillaEmailCompletada: ""
              });
              tareaMaterialPadre = tareaPAPadre.children?.find(
                (t) =>
                  t.Descripcion ===
                    material?.Codigo + " - " + material?.Descripcion &&
                  t.IdMaterial === material?.IdMaterial
              );
            }
            tareaMaterialPadre?.children?.push({
              ...tarea,
              FaseText: fase?.Descripcion,
            });
          } else {
            tareaPAPadre?.children?.push({
              ...tarea,
              FaseText: fase?.Descripcion,
            });
          }
        } else {
          this.GestionTareas.push({ ...tarea, FaseText: fase?.Descripcion });
        }
      });
      const { sortChildrenRecursively } = Helper()
      sortChildrenRecursively(this.GestionTareas);
    },
    async AddTarea(data: TareaBBDD) {
      await services.TareaService.add(data)
        .then(() => {
          console.log("Tarea añadida correctamente");
        })
        .catch((error: Error) => {
          console.error("Error al añadir la fase:", error);
        });
    },
    async UpdateTarea(data: TareaBBDD) {
      await services.TareaService.update(data)
        .then(() => {
          console.log("Tarea update correctamente");
        })
        .catch((error: Error) => {
          console.error("Error al actualizar la tarea:", error);
        });
    },
    async DeleteTarea(idTarea: number) {
      await services.TareaService.delete(idTarea)
        .then(() => {
          console.log("Tarea eliminada correctamente");
        })
        .catch((error: Error) => {
          console.error("Error al eliminar la fase:", error);
        });
    },
    async SAPAutoconsumo(data:TareaBBDD) {
      const ProductoAcabadoStore = useProductosAcabadoStore()
      const pa = await ProductoAcabadoStore.GetProductosAcabadosByIds([data.IdPA])
      if (pa && pa.data && pa.data.length > 0) {
        await services.SAPService.createPrice(pa.data[0])
        .then((response: any) => {
          console.log("Se ha enviado correctamente a SAP Autoconsumo", response);
          ElNotification.success({
            showClose: true,
            message: "Se ha enviado correctamente a SAP Autoconsumo",
          });
        })
        .catch((error: Error) => {
          console.error("Error al enviar a SAP Autoconsumo:", error);
          ElNotification.error({
            showClose: true,
            message: "Se ha producido un error al enviar a SAP Autoconsumo: " + error.message,
          });
        });
      }
    },
    EmptyTareas() {
      this.Tareas = { data: [], links: [] };
      this.TareasIdProyecto = [];
      this.TareasLoaded = false;
    },
    async GetTareasConfiguracion() {
      const ElLoadingInstance = ElLoading.service({ fullscreen: true });
      try {
        const data = (await services.ConfiguracionService.getByKey("Tareas"))
          .data;
        this.TareasConfiguracion = JSON.parse(data.Valor);

        this.TareasConfiguracion.forEach((config) => {
          config.Tareas.forEach((tarea) => {
            if (typeof tarea.Dependencia !== "string") {
              tarea.Dependencia = String(tarea.Dependencia);
            }
          });
        });

        ElLoadingInstance.close();
      } catch (error: any) {
        console.log("GetTareasConfiguracion", error);
        ElLoadingInstance.close();
        ElNotification.error({
          showClose: true,
          message: "Se ha producido un error al obtener las tareas.",
        });
      }
    },
    UpdateTareasConfiguracion(
      data: TareaConfiguracion[],
      equipoSelected: string,
      subequipoSelected: string | null
    ) {
      const ElLoadingInstance = ElLoading.service({ fullscreen: true });
      const tareasEditedIndex = this.TareasConfiguracion.findIndex(
        (t) => t.Key === equipoSelected || t.Key === subequipoSelected
      );
      this.TareasConfiguracion[tareasEditedIndex].Tareas = data;
      const dataConfig: Configuracion = {
        Key: "Tareas",
        Valor: JSON.stringify(this.TareasConfiguracion),
      };
      services.ConfiguracionService.update(dataConfig)
        .then(() => {
          ElLoadingInstance.close();
          ElNotification.success({
            showClose: true,
            message: "Se ha guardado correctamente las tareas",
          });
        })
        .catch(() => {
          ElLoadingInstance.close();
          ElNotification.error({
            showClose: true,
            message: "Se ha producido un error al guardar las tareas.",
          });
        });
    },
    UpdateTareaConfiguracionStore(
      tareaActualizada: TareaConfiguracion,
      equipoSelected: string,
      subequipoSelected: string | null
    ) {
      // TODO
      console.log(tareaActualizada);
      const tareasEditedIndex = this.TareasConfiguracion.findIndex(
        (t) => t.Key === equipoSelected || t.Key === subequipoSelected
      );
      if (tareasEditedIndex === -1) {
        this.TareasConfiguracion.push({
          Key: subequipoSelected ? subequipoSelected : equipoSelected,
          Tareas: [tareaActualizada],
        });
      } else {
        const indexTarea = this.TareasConfiguracion[
          tareasEditedIndex
        ].Tareas.findIndex((t) => t.Id === tareaActualizada.Id);
        if (indexTarea === -1) {
          this.TareasConfiguracion[tareasEditedIndex].Tareas.push(
            tareaActualizada
          );
        } else {
          this.TareasConfiguracion[tareasEditedIndex].Tareas[indexTarea] =
            tareaActualizada;
        }
      }
    },
    CopiarTareasConfiguracionStore(
      equipoSelectedOrigen: string,
      subequipoSelectedOrigen: string | null,
      equipoSelectedDestino: string,
      subequipoSelectedDestino: string | null
    ) {
      const tareasEditedIndex = this.TareasConfiguracion.findIndex(
        (t) =>
          t.Key === equipoSelectedOrigen || t.Key === subequipoSelectedOrigen
      );
      if (tareasEditedIndex === -1) {
        ElNotification.error({
          showClose: true,
          message: "Se han encontrado tareas.",
        });
      } else {
        const tareasConfigIndex = this.TareasConfiguracion.findIndex(
          (t) =>
            t.Key === equipoSelectedDestino ||
            t.Key === subequipoSelectedDestino
        );
        if (tareasConfigIndex === -1) {
          this.TareasConfiguracion.push({
            Key: subequipoSelectedDestino
              ? subequipoSelectedDestino
              : equipoSelectedDestino,
            Tareas: structuredClone(this.TareasConfiguracion[tareasEditedIndex].Tareas),
          });
        } else {
          this.TareasConfiguracion[tareasConfigIndex].Tareas =
          structuredClone(this.TareasConfiguracion[tareasEditedIndex].Tareas);
        }
      }
    },
    RemoveTareaConfiguracionStore(
      idTarea: number,
      equipoSelected: string,
      subequipoSelected: string | null
    ) {
      const tareasEditedIndex = this.TareasConfiguracion.findIndex(
        (t) => t.Key === equipoSelected || t.Key === subequipoSelected
      );
      if (tareasEditedIndex > -1) {
        {
          const indexTarea = this.TareasConfiguracion[
            tareasEditedIndex
          ].Tareas.findIndex((t) => t.Id === idTarea);
          if (indexTarea > -1) {
            this.TareasConfiguracion[tareasEditedIndex].Tareas.splice(
              indexTarea,
              1
            );
          }
        }
      }
    },
    async UpdateProjectTasks(
      proyecto: Proyecto,
      prodAcabado: ProductoAcabado | null,
      material: Material | null,
      tareaCompletada: TareaBBDD | null = null,
      materialCambioCodigo: boolean = false
    ) {
      await services.AzureService.updateProjectTasks(
        proyecto,
        prodAcabado,
        material,
        tareaCompletada,
        materialCambioCodigo
      );
    },
    DeleteTareas(id: number, tipoTarea: string) {
      services.AzureService.deleteProjectTaks(id, tipoTarea);
    },
    async NotificarTareas(
      proyecto: Proyecto,
      prodAcabado: ProductoAcabado | null,
      material: Material | null,
      tareaCompletada: TareaBBDD
    ) {
      await services.AzureService.notificarTareas(
        proyecto,
        prodAcabado,
        material,
        tareaCompletada
      );
    },
  },
});
